export function ImmerseTestimonials() {
    return (
        <iframe
            id="testimonialto-grid-selected-email-testimonials-light-animated"
            src="https://embed.testimonial.to/w/email-testimonials?animated=on&amp;theme=light&amp;shadowColor=transparent"
            frameBorder="0"
            scrolling="no"
            width="100%"
            height="800px">
        </iframe>
    )
}